import { render, staticRenderFns } from "./BeatClock.vue?vue&type=template&id=cb7ce85e&scoped=true&"
import script from "./BeatClock.vue?vue&type=script&lang=js&"
export * from "./BeatClock.vue?vue&type=script&lang=js&"
import style0 from "./BeatClock.vue?vue&type=style&index=0&id=cb7ce85e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7ce85e",
  null
  
)

export default component.exports